'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _termsModule = require('./termsModule');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createHTMLMarkup = function createHTMLMarkup(html) {
  return { __html: html };
};

var TermsPage = function (_React$Component) {
  _inherits(TermsPage, _React$Component);

  function TermsPage() {
    _classCallCheck(this, TermsPage);

    return _possibleConstructorReturn(this, (TermsPage.__proto__ || Object.getPrototypeOf(TermsPage)).apply(this, arguments));
  }

  _createClass(TermsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchLOAContent();
    }
  }, {
    key: 'render',
    value: function render() {
      var loaHtml = this.props.loaHtml;


      var re = /<style>\s+(.*)\s+<\/style>/;
      loaHtml = loaHtml && loaHtml.replace(re, '$1');

      return _react2.default.createElement('div', {
        style: { padding: '20px', fontSize: '1.2em', lineHeight: '1.6' },
        dangerouslySetInnerHTML: createHTMLMarkup(loaHtml)
      });
    }
  }]);

  return TermsPage;
}(_react2.default.Component);

TermsPage.propTypes = {
  fetchLOAContent: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  var _state$terms = state.terms;
  _state$terms = _state$terms === undefined ? {} : _state$terms;
  var _state$terms$loa$cont = _state$terms.loa.content;
  _state$terms$loa$cont = _state$terms$loa$cont === undefined ? {} : _state$terms$loa$cont;
  var loaHtml = _state$terms$loa$cont.html;


  return { loaHtml: loaHtml };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, { fetchLOAContent: _termsModule.fetchLOAContent })(TermsPage);


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsPage.js
// module id = 598
// module chunks = 0